export default function EmotionalSection() {
  return (
    <section className="w-full relative overflow-hidden py-24 md:py-40">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20young%20woman%20wearing%20delicate%20custom%20gold%20necklace%20close-up%20of%20neck%20and%20collarbone%2C%20soft%20warm%20cinematic%20lighting%2C%20luxurious%20atmosphere%2C%20minimal%20background%2C%20intimate%20emotional%20moment%2C%20jewelry%20lifestyle%20photography%2C%20feminine%20beauty%2C%20dark%20moody%20elegant%20tones&width=1200&height=600&seq=8&orientation=landscape"
          alt="Duygusal bağlantı"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-luxury-black/75" />
        <div className="absolute inset-0 bg-gradient-to-r from-luxury-black/90 via-luxury-black/60 to-luxury-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <div className="reveal">
            <span className="font-sans text-gold text-xs tracking-luxury uppercase">
              Anlam
            </span>
          </div>

          <h2 className="reveal reveal-delay-1 font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light mt-6 leading-snug">
            Kendin için…
            <br />
            <em className="text-gold-gradient not-italic">ya da sevdiklerin için</em>
            <br />
            unutulmayacak bir parça.
          </h2>

          <div className="reveal reveal-delay-2 gold-line w-16 my-8" />

          <div className="reveal reveal-delay-3 flex flex-col gap-6">
            {[
              {
                icon: 'ri-heart-3-line',
                label: 'Sevgi',
                text: 'Sevdiklerinize verdiğiniz en güzel hediye.',
              },
              {
                icon: 'ri-star-line',
                label: 'Anlam',
                text: 'Her bakışta sizin hikâyenizi anlatan bir parça.',
              },
              {
                icon: 'ri-time-line',
                label: 'Kalıcılık',
                text: 'Altının ömrü boyunca taşınan bir hatıra.',
              },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-5 group">
                <div className="w-10 h-10 flex items-center justify-center luxury-border flex-shrink-0 group-hover:border-gold/60 transition-colors duration-300">
                  <i className={`${item.icon} text-gold text-sm`} />
                </div>
                <div>
                  <span className="font-sans text-gold text-xs tracking-luxury uppercase">
                    {item.label}
                  </span>
                  <p className="font-sans text-white/60 text-sm">{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="reveal reveal-delay-4 mt-10">
            <p className="font-serif text-2xl text-white/80 italic leading-relaxed">
              &ldquo;Bir takı; sadece metal ve taş değil,
              <br />
              dondurulmuş bir his, sonsuza taşınan bir an.&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
